import styled from '@emotion/styled';

import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

export const TotalPriceContainer = styled.div`
	width: 100%;
	margin-top: var(--margin-1);
	background-color: var(--white);
	padding: var(--padding-3) var(--padding-5);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);

	@media ${Breakpoints.mobile} {
		border: none;
	}
`;

export const TotalPriceRow = styled.div`
	display: flex;
	justify-content: space-between;

	&.expanded {
		> div > .expandIcon > svg {
			transition: transform 0.6s ease;
			transform: rotate(180deg);
		}
	}

	@media ${Breakpoints.mobile} {
		margin-bottom: var(--margin-2);
	}
`;

export const TotalPriceHr = styled.hr`
	border: unset;
	border-bottom: 1px solid var(--border-color);
	margin: var(--margin-3) 0;
`;

export const ExpandIcon = styled(Icon)`
	> svg {
		transition: transform 0.6s ease;
		width: 1rem;
		margin-right: var(--padding-1);

		body[dir='rtl'] & {
			transform: rotate(180deg);
			margin-right: unset;
			margin-left: var(--padding-1);
		}
	}
`;
